(() => {
  const carousels = document.querySelectorAll('[data-product-carousel]');

  carousels.forEach((carousel) => {
    if (typeof Splide === 'undefined') return;

    new Splide(carousel, {
      type: 'slide',
      perPage: 1,
      fixedWidth: '70vw',
      gap: 'var(--page-margin)',
      padding: {
        left: 'var(--page-margin)',
        right: 'var(--page-margin)'
      },
      arrows: false,
      pagination: false,
      drag: true,
      snap: true,
      speed: 500,
      focusableNodes: 'a, button, textarea, input, select, iframe, .jdgm-widget a',
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      mediaQuery: 'min',
      breakpoints: {
        551: {
          destroy: true
        }
      }
    }).mount();
  });
})();
